import React from 'react'
import '../App.css'
import Bodygestiontickest from './bodygestiontickets'
export class Bodyappgestionticketsbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                    <Bodygestiontickest/>
                </div>

        );
    }
}